import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { PhaseResultModel, ProjectPhaseOverallResultModel } from '../interfaces/entities/phase';

@Injectable({ providedIn: 'root' })
export class PhasesService {
  private readonly controller: string = 'Phases';

  constructor(private apiService: ApiBaseService) {}

  getAll(): Promise<PhaseResultModel> {
    return this.apiService.httpRequest(`${this.controller}/GetAllPhases`, {}, true, true);
  }

  getPhasesOverallData(): Promise<ProjectPhaseOverallResultModel> {
    return this.apiService.httpRequest(`${this.controller}/GetPhasesOverallData`, {}, true, true);
  }
}
